import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { shareReplay } from 'rxjs/operators';

import { filterDefined } from '@core/common-legacy';
import { BillingPlansSelectors } from '@recruitee/billing-data';

@Injectable({ providedIn: 'root' })
export class BillingPlansDataService {
  private readonly store = inject(Store);

  public readonly collection$ = this.store
    .select(BillingPlansSelectors.billingPlans)
    .pipe(filterDefined, shareReplay({ bufferSize: 1, refCount: true }));

  public readonly activePlan$ = this.store
    .select(BillingPlansSelectors.activePlan)
    .pipe(shareReplay({ bufferSize: 1, refCount: true }));

  public getRangeForQuantity$(quantity: number | undefined) {
    return this.store.select(BillingPlansSelectors.rangeForQuantity(quantity));
  }
}
